import { FiGrid } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import "../../styles/CatalogButton.css";

export default function CatalogButton({ onClick, disabled }) {
  const { t } = useTranslation("catalog");

  return (
    <button
      type="button"
      className="catalogBtn"
      onClick={onClick}
      aria-label={t("catalog_button")}
      title={t("catalog_button")}
      disabled={disabled}
    >
      <FiGrid className="catalogIcon" />
    </button>
  );
}